import { ready } from './helpers';

import Rails from 'rails-ujs';

ready(() => {
  Rails.start();
});
